"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const base_component_1 = require("../../base-component");
class Card extends base_component_1.BaseComponent {
}
exports.Card = Card;
